<template>
    <el-container>
        
        <el-header style="padding: 0; min-height: 30px;">
            <el-page-header @back="goBack" content="添加商品套餐">
            </el-page-header>
        </el-header>
        
        
        <el-main>
            <el-steps :active="step" simple class="t_top">
                <el-step title="第一步：课程套餐基本信息" icon="el-icon-edit"></el-step>
                <el-step title="第二步：课程套餐简介" icon="el-icon-upload"></el-step>
                <el-step title="第三步：课程套餐内容" icon="el-icon-picture"></el-step>
            </el-steps>
            
            <template v-if="step == 1">
                <el-form ref="courseForm" :model="form" :rules="rules" label-width="150px"
                         class="demo-ruleForm t_center" align="left">
                    <el-form-item label="课程名称:" prop="courseName">
                        <el-input v-model="form.courseName" placeholder="课程名称" @input="searchCommodityinfoByAll"></el-input>
                    </el-form-item>
                    <el-form-item label="课程英文名称:" prop="courseEnglishName" v-if="loginOrgCode == 'blcuonline'">
                        <el-input v-model="form.courseEnglishName" placeholder="课程名称" @input="searchCommodityinfoByAll" ></el-input>
                    </el-form-item>
                    <el-form-item label="主营类目:" prop="ccId" style="width: 70%" v-if="loginOrgCode != 'blcuonline'">
                        <el-cascader
                            expand-trigger="hover"
                            change-on-select="true"
                            :options="categoryOptions"
                            v-model="selectedCategory"
                            :props="{ value: 'ccId', label: 'ccName'}"
                            @change="changeCategory">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="特色介绍:" prop="introduce">
                        <el-input v-model="form.introduce" placeholder="特色介绍"></el-input>
                    </el-form-item>
                    <el-form-item label="英文特色介绍:" prop="englishIntroduce" v-if="loginOrgCode == 'blcuonline'">
                        <el-input v-model="form.englishIntroduce" placeholder="特色介绍"></el-input>
                    </el-form-item>
                    <el-form-item label="原价:" prop="price">
                        <el-input v-model="form.price" placeholder="原价"></el-input>
                    </el-form-item>
                    <el-form-item label="优惠价:"
                                  prop="preferential"
                                  :key="form.preferentialBeginTime+form.preferentialEndTime"
                    >
                        <el-input v-model="form.preferential" placeholder="优惠价"></el-input>
                    </el-form-item>
                    <el-form-item label="优惠时间:"
                                  :required="form.preferentialBeginTime || form.preferentialEndTime?true:false"
                    >
                        <el-date-picker
                            v-model="form.preferentialBeginTime"
                            type="datetime"
                            placeholder="选择开始日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :append-to-body=false
                            :picker-options="startTime"
                        >
                        </el-date-picker>
                        <span style="margin: 0px 10px;">-</span>
                        <el-date-picker
                            v-model="form.preferentialEndTime"
                            :append-to-body=false
                            type="datetime"
                            placeholder="选择结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="endTime"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="课时标准:" prop="standard" v-if="loginOrgCode != 'blcuonline'">
                        <el-input v-model="form.standard" placeholder="课时标准"></el-input>
                    </el-form-item>
                    <el-form-item label="购买人数:" prop="persionNum">
                        <el-input v-model="form.persionNum" placeholder="购买人数"></el-input>
                    </el-form-item>
                    <el-form-item label="课时:" prop="classTime" >
                        <el-input v-model="form.classTime" placeholder="课时"></el-input>
                    </el-form-item>
                   <el-form-item label="有效期:" prop="validity" ref="">
                      <el-radio v-model="form.validityType" :label="1" @change="changeValidityType">永久</el-radio>
                      <el-radio v-model="form.validityType" :label="2" @change="changeValidityType">
                          <span class="input_">
                                <el-input  v-model="form.validity"  @input="checkValidity"  placeholder="有效期" >
                                    <template slot="append">天</template>
                                </el-input>
                          </span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item  label="开班日期:" prop="openClassTime">
                        <el-radio v-model="form.openClassType" :label= "1" @change="changeOpenClass">随时</el-radio>
                        <el-radio v-model="form.openClassType" :label= "2" @change="changeOpenClass" >
                            <el-date-picker
                                v-model="form.openClassTime"
                                type="date"
                                @change="changeOpenClass"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-radio>
    
                    </el-form-item>
                    <el-form-item label="授课类型:" prop="lessonType" v-if="loginOrgCode != 'blcuonline'">
                        <el-select placeholder="" size="small" v-model="form.lessonType">
                            <el-option label="直播" :value="1"></el-option>
                            <el-option label="面授" :value="2"></el-option>
                            <el-option label="录播" :value="3"></el-option>
                            <el-option label="录播+直播" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汉语水平:"  v-if="loginOrgCode == 'blcuonline'">
                        <el-select placeholder="" size="small" v-model="form.lessonType">
                            <el-option label="入门" :value="11"></el-option>
                            <el-option label="初级" :value="12"></el-option>
                            <el-option label="中级" :value="13"></el-option>
                            <el-option label="高级" :value="14"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="所属机构:" prop="orgCode" v-if="loginOrgCode != 'blcuonline'" >
                        <el-select  placeholder="" size="small" placeholder="机构" v-model="form.orgCode" @change="changeLecturer">
                            <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机构商品分类:" :inline="true" v-if="showOrgCC" prop="orgCcId" style="width: 100%">
                        <el-cascader
                            expand-trigger="hover"
                            change-on-select="true"
                            size="small"
                            :options="categoryOrgOptions"
                            :props="{ value: 'ccId', label: 'ccName'}"
                            v-model="selectedOrgCategory"
                            @change="changeCategory">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="主讲老师:" >
                        <el-select v-model="form.lecturer"
                                   multiple
                                   filterable
                                   style="width: 100%;"
                                   placeholder="请选择">
                            <el-option
                                v-for="item in teacherList"
                                :key="item.teacherId"
                                :label="item.teacherName"
                                :value="item.teacherId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="试听视频:" prop="auditionVideoPath">
                        <FileUpload
                            @changeAuditionVideoStrList="changeAuditionVideoStrList"
                            :auditionVideoStrListTemp = "form.auditionVideoStrList"
                        >
    
                        </FileUpload>
                    </el-form-item>
                    <el-form-item label="宣传视频:" prop="auditionVideoPath">
                            <div v-show="uploadMethodDataType == 1">
                                <el-upload
                                    :action="uploadURL"
                                    :headers="myHeaders"
                                    ref="auditionVideo"
                                    :on-preview="handleAutoCardPreview"
                                    :on-remove="auditionVideoHandleRemove"
                                    :on-change="auditionVideoOnChange"
                                    :on-success="auditionVideoHandleSuccess"
                                    :before-upload="auditionVideoBeforeAvatarUpload"
                                    :limit="1"
                                    :file-list="auditionVideoFileList"
                                    :show-file-list="true"
                                    :auto-upload="false"
                                    style="width: 50%"
                                    :class="{'avatar-video': true, 'hide': hideAuditionVideoUpload}"
                                >
                                    
                                    <el-button slot="trigger" size="small" @click="uploadMethod(1)" type="primary">选取文件</el-button>
                                    <el-button type="primary" size="small" @click="uploadMethod(2)" class="but-cls" style="margin-left: 10px">填写链接</el-button>
                                    <div v-show="uploadMethodData == 1">
                                    <div slot="tip" class="el-upload__tip">建议MP4格式，视频不宜太大</div>
                                    <video controls="controls" style="display: none" id="aa" @canplaythrough="videoDuration(this)">
                                    </video>
                                    <el-progress :percentage="percent" status="success"></el-progress>
                                    </div>
                                </el-upload>
                            <div v-show="uploadMethodData == 2">
                                <el-form-item label="视频名称:" prop="pathName" label-width="80px">
                                    <el-input v-model="pathName" placeholder="视频名称" style="width: 50%; margin-bottom: 10px;"></el-input>
                                </el-form-item>
                
                                <el-form-item label="视频链接:" prop="videoPath" label-width="80px">
                                    <el-input v-model="videoPath" placeholder="视频链接" style="width: 50%; margin-bottom: 10px;"></el-input>
                                </el-form-item>
                                <el-form-item align="center">
                                    <el-button type="primary" size="small" @click="confirmUpload()" class="but-cls">确定上传</el-button>
                                </el-form-item>
                            </div>
                        </div>
                        <div v-show="uploadMethodDataType == 2">
                            <el-tag
                                v-if="form.auditionVideoVo"
                                :disable-transitions="false"
                            >
                                {{form.auditionVideoVo.fileName}}
                            </el-tag>
                            <!--<div v-show='!isRtmp'>
                                <video controls="controls" :src="videoSrc" @canplaythrough="videoDuration(this)" style="width: 50%">
                                </video>
                            </div>
                            <div v-show='isRtmp'>
                                <object v-bind:data="rtmpParam.data" type="application/x-shockwave-flash" width="500" height="300" id="player">
                                    <param name="movie" v-bind:alue="rtmpParam.movie">
                                    <param name="wmode" value="transparent">
                                    <param name="allowFullScreen" value="true">
                                    <param name="allowScriptAccess" value="always">
                                </object>
                            </div>-->
                            <el-button type="primary" size="small" @click="reUpload()" class="but-cls" style="margin-left: 10px">
                                重新上传
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="课程封面:" prop="picturePath">
                        <el-upload
                            v-model="form.picturePath"
                            :action="uploadURL"
                            :headers="myHeaders"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="pictureHandleRemove"
                            :on-change="pictureOnChange"
                            :on-success="pictureHandleSuccess"
                            :before-upload="pictureBeforeAvatarUpload"
                            :limit="2"
                            :file-list="pictureFileList"
                            :show-file-list="true"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" size="tiny">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <el-form-item label="自营排序:" prop="sort" v-if="orgType == 1">
                        <el-input v-model="form.sort" placeholder="排序"></el-input>
                    </el-form-item>
                    <el-form-item label="机构排序:" prop="orgSort" v-if="showOrgCC">
                        <el-input v-model="form.orgSort" placeholder="排序"></el-input>
                    </el-form-item>
                    <el-form-item label="咨询方式:" prop="contactInfo">
                        <el-input v-model="form.contactInfo" placeholder="请输入QQ号码"></el-input>
                    </el-form-item>
                    <el-form-item align="center">
                        <el-button type="primary" @click="saveAndNext(1)">保存，进入下一步</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template v-if="step == 2">
                <el-form ref="form" class="t_center1">
                    <el-form-item label="简介:">
                    </el-form-item>
                    <el-form-item>
                        <ckeditor v-model="form.courseIntroduce"></ckeditor>
                    </el-form-item>
                    <el-form-item label="英文简介:" v-if="loginOrgCode == 'blcuonline'">
                    </el-form-item>
                    <el-form-item   v-if="loginOrgCode == 'blcuonline'">
                        <ckeditor v-model="form.courseEnglishIntroduce"></ckeditor>
                    </el-form-item>
                    <el-form-item align="center">
                        <el-button @click="prev">上一步</el-button>
                        <el-button type="primary" @click="saveAndNext(2)">保存，进入下一步</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template v-if="step == 3">
                <el-row v-for="(o, index) in Math.floor(commodity.length/4+1)"
                     :key="o">
                    <el-col :span="5" v-for="(a,i) in commodity.slice(index*4,(index*4+4))" :offset="i > 0 ? 1 : 0"
                            style="margin-bottom: 10px">
                        <el-card :body-style="{ padding: '0px',height: '150px'}">
                            <div style="width: 100px; height: 150px; line-height:140px; float: left; margin-left: 3px;">
                                <img :src="a.picturePathView" class="image" style="display: inline-block; vertical-align: middle;">
                            </div>
                            <div style="padding-left: 7px; float: left">
                                <span style="font-size: 15px; line-height: 10px;">{{a.courseName}}</span>
                                <div class="bottom clearfix">
                                    <time class="time">￥ {{a.preferential}}</time>
                                </div>
                                <div class="bottom clearfix">
                                    <time class="time" v-if="a.teacherList.length>0">讲师：
                                        <el-tooltip class="item" effect="dark" :content="a.teacherList" placement="top">
                                            <span class="sub_teacher" >{{a.subTeacher | teacherFilter}} </span>
                                        </el-tooltip>
                                    </time>
                                </div>
                                <div class="bottom clearfix">
                                    <time class="time">授课类型：
                                        <span v-if="a.lessonType == 1">直播</span>
                                        <span v-if="a.lessonType == 3">录播</span>
                                        <span v-if="a.lessonType == 2">面授</span>
                                        <span v-if="a.lessonType == 4">直播+录播</span>
                                        <span v-if="a.classTime">课时：{{a.classTime}}</span>
                                    </time>
                                </div>
                               
                            </div>
                            <div style="float: right; margin-top: 30px; ">
                              <el-button type="text" class="button" @click="next(a)" style="margin-right: 5px;">后移</el-button>
                              <el-button type="text" class="button" @click="pre(a)" style="margin-right: 5px;">前移</el-button>
                              <el-button type="text" class="button" @click="deleteCommodity(a)">删除</el-button>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="5" style="margin-bottom: 10px" :offset="commodity.length%4==0?0:1" v-if="index+1 == Math.floor(commodity.length/4+1)">
                        <el-card :body-style="{ padding: '0px' }">
                            <div
                                style="width: 100%; height: 150px; line-height:140px; float: left; font-size: 70px; color: #d7d6d6; text-align: center; cursor: pointer"
                                @click="selectCommodity">
                                +
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                
                <el-row >
                    <el-col :offset="0" >
                        <el-form ref="staffForm" :model="form" :rules="rules" label-width="120px"
                                 class="demo-ruleForm " align="left" label-position="left">
                            <span style="font-size: 14px;color: #606266">
                                注意：此处关联的课程是已被平台审核通过的课程
                            </span>
                            <el-form-item label="套餐类型:" prop="mealType">
                                <el-radio v-model="form.mealType" :label="0" >固定套餐</el-radio>
                                <el-radio v-model="form.mealType" :label="1" >可选套餐</el-radio>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form ref="staffForm" :model="form" :rules="rules" label-width="80px"
                                 class="demo-ruleForm t_center" align="left">
                            <el-form-item align="center">
                                <el-button @click="prev">上一步</el-button>
                                <el-button type="primary" @click="saveAndNext(3)">保存</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-dialog title="请选择商品" :visible.sync="showCommodity" :close-on-click-modal=false width="950px">
                    <div class="edit_transfer">
                        <el-transfer
                            v-model="selectedCommodiys"
                            :props="{key:'commodityId',label: 'courseName'}"
                            :left-default-checked="leftChecked"
                            :right-default-checked="rightChecked"
                            filterable
                            :titles="['选择课程', '已选课程']"
                            :data="commodityData">
                        </el-transfer>
                    </div>
                    
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showCommodity = false">取 消</el-button>
                        <el-button type="primary" @click="saveCommodity()">确 定</el-button>
                    </div>
                </el-dialog>
            </template>
        </el-main>
    </el-container>
</template>

<script>
  import https from '@/https.js';
  import Base64 from '@/api/video/lib/base64.js';
  import alioss from '@/api/video/ali-oss.js';
  import AliyunUpload from 'aliyun-upload-vod';
  import Crypto from 'crypto-js';
  import OSS from 'ali-oss';
  import validate from '@/api/validate.js';
  import { lineHeightStyle } from '@/api/lineHeight.js';
  import Quill from 'quill';
  import ckeditor from "@/components/ckeditor/ckeditor.vue";
  import FileUpload from '@/components/FileUpload/FileUpload.vue';
  import AliPlayer from '@/components/AliPlayer/AliPlayer.vue';
  import {dateFormat} from '@/api/utils.js';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean'],
    ['code-block'],
    [{ lineheight: ['initial', '1', '1.5', '1.75', '2', '3', '4', '5'] }],
  ];
  var duration;
  export default {
    name: 'addCommodityPackage',
    components: { ckeditor ,FileUpload,"ali-player": AliPlayer,dateFormat},
    data() {
      var validPeriod = (rule, value, callback) => {
        const reg = /^\d{1,4}$/
        console.log(value);
        if(this.form.validityType == 1) {
          callback();
        } else if (value === '' || value < 0) {
          callback(new Error('有效期不能为0,负数或者空'));
        } else if(!reg.test(value)) {
          callback(new Error('只允许输入1-9999的正整数'));
        } else {
          callback();
        }
      };
      return {
        startTimeHoursRule:'00:00:00 - 23:59:59',
        endTimeHoursRule:'00:00:00 - 23:59:59',
        startTime: {
          disabledDate: time => {
            if (this.form.preferentialEndTime) {
              return (
                  time.getTime() >= new Date(this.form.preferentialEndTime).getTime()
              );
            }
          }
        },
        endTime: {
          disabledDate: time => {
            if (this.form.preferentialBeginTime) {
              return (
                  time.getTime() <= new Date(this.form.preferentialBeginTime).getTime() - 1 * 24 * 60 * 60 * 1000
              );
            }
          }
        },
        leftChecked: [],
        rightChecked: [],
        commodityData: [],
        selectedCommodiys: [],
        showCommodity: false,
        commodityIndex: 10,
        rowIndex: 3,
        commodity: [
        
        ],
        currentDate: '2019-11-11 11:11:11',
        rules: {
          courseName: [
            { required: true, message: '请输入课程名称', trigger: 'blur' },
            { max:200, message: '长度不得超过200个字符', trigger: 'blur' }
          ],
          courseEnglishName: [
            {required: true, message: '请输入课程名称', trigger: 'blur'},
            {max: 200, message: '长度不得超过200个字符', trigger: 'blur'}
          ],
          ccId:[
            { required: true, message: '请选择分类', trigger: 'blur' }
          ],
          introduce: [
            { required: true, message: '请输入特色介绍', trigger: 'blur' },
            { max:30, message: '长度不得超过30个字符', trigger: 'blur' }
          ],
          englishIntroduce: [
            {required: true, message: '请输入特色介绍', trigger: 'blur'},
            {max: 100, message: '长度不得超过100个字符', trigger: 'blur'}
          ],
          price: [
            { required: true, message: '请输入价格', trigger: 'blur' },
            { validator: validate.validatePrice, trigger: 'blur' }
          ],
          preferential: [
            { validator: validate.validatePreferentialPrice, trigger: 'blur' }
          ],
          standard: [
            { required: true, message: '请输入课时标准', trigger: 'blur' },
            { validator: validate.validatePreferentialPrice, trigger: 'blur' }
          ],
          persionNum: [
            { required: true, message: '请输入人数', trigger: 'blur' },
            { validator: validate.validateNumber, trigger: 'blur' }
          ],
          orgCcId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          classTime: [
            { validator: validate.validateClassTime, trigger: 'blur' }
          ],
          validity: [
            {validator: validPeriod, trigger: 'change'}
          ],
          openClassTime: [
            { required: true, message: '请选择开班日期', trigger: 'blur' }
          ],
          lessonType: [
            { required: true, message: '请选择授课类型', trigger: 'blur' }
          ],
          orgCode: [
            { required: true, message: '请选择所属机构', trigger: 'blur' }
          ],
          picturePath: [
            { required: true, message: '请上传课程封面', trigger: 'change' }
          ],
          isView: [
            { required: true, message: '请选择是否显示', trigger: 'blur' }
          ],
          isPacking: [
            { required: true, message: '请选择是否打包', trigger: 'blur' }
          ],
          // auditionVideoPath: [
          //   { required: true, message: '请上传试听视频', trigger: 'blur' }
          // ],
          mealType: [
            {required: true, message: '请选择套餐类型', trigger: 'blur'}
          ],
          contactInfo: [
            { validator: validate.validateQQ, trigger: 'blur' }
          ],
          lecturer: [
            { required: true, message: '请选择主讲老师', trigger: 'blur' }
          ]
        },
        autoIsUpload: false,
        uploadMethodData: '1',
        uploadMethodDataType: '1',
        dialogAuditionVideo: false,
        videoSrc: '',
        videoType: '',// 1: 阿里h5 0: 其他
        loaded: false,
        vid: '',
        playAuth: '',
        encryptType: 1,
        videoPath: '',
        pathName: '',
        form: {
          courseType: '1',
          commodityId: '',
          comCommodityId: '',
          courseName: '',
          ccId: '',
          orgCcId: '',
          ccPId: '',
          price: '',
          validity: '',
          validityType: 1,
          introduce: '',
          preferential: '',
          persionNum: '',
          auditionVideoVo: {},
          classTime: '',
          openClassType: 1,
          openClassTime: dateFormat(new Date()),
          lessonType: 1,
          commodityLecturerList: [],
          lecturers: [],
          lecturer: [],
          auditionVideoPath: '',
          auditionVideoPathView: '',
          auditionVideoStrList: [],
          picturePath: '',
          picturePathView: '',
          courseIntroduce: '',
          courseId: '',
          orgCode: '',
          contactInfo: '',
          autoMessage: false,
          standard: '',
          sort: '',
          orgSort: '',
          isView: 1,
          isPacking: 0,
          commodityList: [],
          mealType: 0,
          commodityStatus:2,
          preferentialBeginTime: null,
          preferentialEndTime: null,
        },
        isShowCropper: false,
        fileinfo: {},
        org: [],
        orgType:'',
        courseName: '',
        courseId: '',
        step: 1,
        courseData: [],
        courseChild: [],
        courseChildData: {},
        uploadURL: '',
        myHeaders: {
          Authentication: localStorage.getItem("token")
        },
        hidePictureUpload: false,
        hideAuditionVideoUpload: false,
        pictureLimitCount: 1,
        auditionVideoLimitCount: 1,
        pictureFileList: [],
        auditionVideoFileList: [],
        dialogVisible: false,
        dialogImageUrl: '',
        teacherList: [],
        teacherData: [],
        teacherData1: [],
        loading: false,
        quillUpdateImg: false,
        courseList: [],
        disableCourse: false,
        video: {
          videoInfoId: '',
          videoInfoName: '',
          duration: '',
          bak2: ''
        },
        src: 'https://live.eblcu.cn/',
        version: 'player.v2.swf',
        _parm: '',
        isAutoStart: 'true',
        isOldAddress: 'true',
        isRtmp: false,
        rtmpParam: {
          data: '',
          movie: ''
        },
        percent: 0,
        categoryOptions: [],
        courseOptions: [],
        selectedCourse: [],
        selectedCategory: [],
        selectedOrgCategory: [],
        categoryOptionsMap: {},
        categoryOrgOptions: [],
        categoryOrgOptionsMap: {},
        showOrgCC: false,
        loginOrgCode: '',
        editorOption: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function(value) {
                  if (value) {
                    document.querySelector('.avatar-uploader input').click();
                  } else {
                    this.quill.format('image', false);
                  }
                },
                lineheight: function (value) {
                  if (value) {
                    this.quill.format('lineHeight', value);
                  } else {
                    console.log(value);
                  }
                },
              }
            }
          }
        },
        editorOptionEnglish: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function(value) {
                  if (value) {
                    document.querySelector('.avatar-uploaderEnglish input').click();
                  } else {
                    this.quill.format('image', false);
                  }
                }
              }
            }
          }
        },
      };
    },
    methods: {
      ready() {
        console.log(Quill);
        Quill.register({ 'formats/lineHeight': lineHeightStyle }, true);
      },
      changeAuditionVideoStrList(auditionVideoStrList) {
        this.form.auditionVideoStrList = auditionVideoStrList;
      },
      reUpload() {
        this.auditionVideoHandleRemove();
        this.videoSrc = '';
        this.videoPath = '';
        this.pathName = '';
        this.uploadMethodDataType = 1;
      },
      parm(url, mediaURL) {
        this._parm = '?';
        this._parm += 'url=' + url + '&&';
        this._parm += 'filename=' + mediaURL + '&&';
        this._parm += 'isAutoStart=' + this.isAutoStart + '&&';
        this._parm += 'isOldAddress=' + this.isOldAddress + '&&';
      },

      selectPlayer() {
        let url = this.videoSrc;
        this.isRtmp = false;
        if(!url) {
          return;
        }
        if (url.indexOf('rtmp://live.teblcu.com') >= 0) {
          this.isRtmp = true;
          let urls = url.split('/mp4:');
          let url1 = urls[0];
          let mediaURL = urls[1];
          this.parm(url1, mediaURL);
          // data this.src+this.getVersion()+this.parm()
          this.rtmpParam.data = this.src + this.version + this._parm;
          this.rtmpParam.movie = this.src + this.version + this._parm;
        }
      },

      showVideo() {
        console.log(this.videoSrc);
        if (this.videoSrc == '') {
          this.$message({
            type: 'info',
            message: '视频未上传！'
          });
          return;
        }
        this.selectPlayer();
        this.dialogAuditionVideo = true;
      },
      confirmUpload() {
        if (this.videoPath == '') {
          this.$message({
            type: 'info',
            message: '视频链接不能为空！'
          });
          return;
        }
        let params = {
          pathName: this.pathName,
          path: this.videoPath
        };
        https.fetchPost('/file/upload_path', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.form.auditionVideoPath = data.data.data.fileId;
            this.videoSrc = this.videoPath;
            this.uploadMethodDataType = 2;
            this.selectPlayer();
            this.$message({
              type: 'success',
              message: '上传成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );

      },
      uploadMethod(val) {
        this.uploadMethodData = val;
      },
      
      selectCommodity() {
        this.searchCommodity();
        this.showCommodity = true;
      },
      getValue() {
        alert(this.form.autoMessage);
      },
      saveCommodity() {
        this.form.commodityList = [];
        for(let i in this.selectedCommodiys) {
          let commodity = {
            commodityId: this.selectedCommodiys[i],
            childCommoditySort: i
          };
          this.form.commodityList.push(commodity);
        }
        let currentCommodity = [];
        for(let i in this.selectedCommodiys) {
          for(let j in this.commodityData) {
            if(this.commodityData[j].commodityId == this.selectedCommodiys[i]) {
              currentCommodity.push(this.commodityData[j]);
            }
          }
        }
        this.commodity = currentCommodity;
        this.showCommodity = false;
      },
      clickFile() {
        document.querySelector('.avatar-uploader input').click();
      },
      submitUpload() {
        let uploadFiles = this.$refs.auditionVideo.uploadFiles;
        if (uploadFiles.length != 1) {
          this.$message({
            type: 'info',
            message: '只能上传一个试听视频'
          });
          return;
        }

        let file = uploadFiles[0].raw;
        let extendName = file.name.substr(file.name.lastIndexOf('.') + 1);
        let videoName = file.name.substr(0, file.name.lastIndexOf('.'));
        let fileSize = file.size;
        let params = {
          extendName: extendName,
          videoName: videoName
        };
        https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.video.videoInfoId = data.data.data.videoInfoId;
            this.video.videoInfoName = data.data.data.videoName+"."+extendName;
            this.video.bak2 = fileSize;
            this.uposs(data.data.data, file);
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleAutoCardPreview() {

      },
      auditionVideoHandleRemove(file, fileList) {
        this.form.auditionVideoVo = {};
        this.$refs.auditionVideo.clearFiles;
        this.auditionVideoFileList = [];
        this.percent = 0;
        this.autoIsUpload = false;
        //this.hideAuditionVideoUpload = fileList.length >= this.auditionVideoLimitCount;
      },
      auditionVideoOnChange(file, fileList) {
        let fileName = file.name;
        let extendName = fileName.substr(file.name.lastIndexOf('.')+1);
        let videoName = fileName.substr(0,file.name.lastIndexOf('.'));
        if(extendName == 'mp4') {
          if(!this.autoIsUpload) {
            this.autoIsUpload = true;
            if(this.loginOrgCode == 'blcuonline') {
              if (this.uploader) {
                this.uploader.stopUpload()
              }
              let userData = '{"Vod":{}}';
              this.uploader = this.createUploader();
              console.log(userData);
              this.uploader.addFile(file.raw, null, null, null, userData);
              if (this.uploader !== null) {
                this.uploader.startUpload()
              }
            } else {
              this.submitUpload();
            }
          }
          console.log(extendName);
        } else {
          this.$message({
            type: 'info',
            message: '只能上传mp4格式视频！'
          });
          this.$refs.auditionVideo.clearFiles;
          this.auditionVideoFileList = [];
        }

      },
      createUploader (type) {
        let self = this
        let uploader = new AliyunUpload.Vod({
          timeout:  60000,
          partSize:  1048576,
          parallel:  5,
          retryCount:  3,
          retryDuration:  2,
          region: 'cn-shanghai',
          userId: '10193998',
          // 添加文件成功
          addFileSuccess: function (uploadInfo) {
            console.log("addFileSuccess: " + uploadInfo.file.name)
          },
          // 开始上传
          onUploadstarted: function (uploadInfo) {
            // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
            // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
            // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
            // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
            let createUrl = '/videoInfo/getAliAuthorization';
            console.log(uploadInfo);
            let params = {
              videoFullName: uploadInfo.file.name,
              videoName: uploadInfo.file.name,
              type: 1
            };
            self.https.fetchPost('/videoInfo/getAliAuthorization', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                let response = data.data.data.response;
                let uploadAuth = response.uploadAuth
                let uploadAddress = response.uploadAddress
                let videoId = response.videoId
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId);
              } else {
                this.$message({
                  type: 'info',
                  message: '上传失败:' + msg
                });
              }
            }).catch(err => {
                  console.log(err);
                }
            );
            console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            /*else {
              // 如果videoId有值，根据videoId刷新上传凭证
              // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
              let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
              axios.get(refreshUrl).then(({data}) => {
                let uploadAuth = data.UploadAuth
                let uploadAddress = data.UploadAddress
                let videoId = data.VideoId
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
              })
            }*/
          },
          // 文件上传成功
          onUploadSucceed: function (uploadInfo) {
            console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            let params = {
              videoId:uploadInfo.videoId
            };
            self.https.fetchPost('/videoInfo/submitTranscodeJob', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                let fileId = data.data.data.fileId;
                let videoInfoId = data.data.data.videoInfoId;
                self.form.auditionVideoPath = videoInfoId;
                self.form.auditionVideoVo = {fileId: videoInfoId,fileName: uploadInfo.file.name}
                self.videoType=1;
                self.uploadMethodDataType = 2;
              } else {
                this.$message({
                  type: 'info',
                  message: '上传失败:' + msg
                });
              }
            }).catch(err => {
                  console.log(err);
                }
            );
          },
          // 文件上传失败
          onUploadFailed: function (uploadInfo, code, message) {
            console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
          },
          // 取消文件上传
          onUploadCanceled: function (uploadInfo, code, message) {
            console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
          },
          // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
          onUploadProgress: function (uploadInfo, totalSize, progress) {
            console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
            let progressPercent = Math.ceil(progress * 100)
            self.percent = progressPercent
          },
          // 上传凭证超时
          onUploadTokenExpired: function (uploadInfo) {
            // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
            // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
            // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
            let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            axios.get(refreshUrl).then(({data}) => {
              let uploadAuth = data.UploadAuth
              uploader.resumeUploadWithAuth(uploadAuth)
              console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
            })
          },
          // 全部文件上传结束
          onUploadEnd: function (uploadInfo) {
            console.log("onUploadEnd: uploaded all the files");
          }
        })
        return uploader
      },
      auditionVideoHandleSuccess(response) {
        this.auditionVideoFileList = [];
        this.form.auditionVideoPath = response.data.fileId;
        this.form.auditionVideoVo = {fileId: response.data.fileId}
        let file = {
          name: '123.png',
          url: response.data.filePath
        };
        this.auditionVideoFileList.push(file);

      },
      auditionVideoBeforeAvatarUpload(file) {
        let params = {
          extendName: 'mp4',
          videoName: '123'
        };
        // this.uposs(d,file);
        https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            this.video.videoInfoId = data.data.data.videoInfoId;
            this.uposs(data.data.data, file);
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );
        return false;
      },
      multiSuccess(result) {
        if (result) {
          if (result.res.status == 200) {
            this.video.duration = document.getElementById('aa').duration;
            let params = {
              videoInfoId: this.video.videoInfoId,
              videoInfoName: this.video.videoInfoName,
              bak2: this.video.bak2,
              duration: parseInt(this.video.duration)
            };
            https.fetchPost('/file/saveVideoPlayUrl', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.form.auditionVideoPath = data.data.data.videoInfoId;
                this.videoSrc = data.data.data.url;
                this.form.auditionVideoVo = {fileId: data.data.data.videoInfoId,fileName: this.video.videoInfoName}
                this.selectPlayer();
                this.uploadMethodDataType = 2;
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败' + msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                  console.log(err);
                }
            );
          }
        }
      },
      multiError() { //上传失败
        parent.blcuvue.open1('上传失败,请重新上传', 'error');
      },
      videoDuration(ele) {
        let duration = document.getElementById('aa').duration;
        if(duration == null) {
          duration = 0;
        }
        this.video.duration = duration;
      },
      uposs(obj, file) {
        var accesskey = obj.accesskeysecret;
        let key = obj.keyWord;
        var accessKeyId = obj.accesskeyid;
        var stsToken = obj.securitytoken;
        var videoInfoId = obj.videoInfoId;
        var urlfile = URL.createObjectURL(file);
        document.getElementById('aa').src = urlfile;
        var policyText = {
          'expiration': '2020-01-01T12:00:00.000Z', //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
          'conditions': [
            ['content-length-range', 0, 10485760000] // 设置上传文件的大小限制
          ]
        };

        var policyBase64 = Base64.Base64.encode(JSON.stringify(policyText));
        var message = policyBase64;
        var bytes = Crypto.HmacSHA1(message, accesskey);
        let signature = bytes.toString(Crypto.enc.Base64);

        console.log(signature);

        let ossClient = new OSS({
          'region': 'oss-cn-beijing',
          'accessKeyId': accessKeyId, //1111
          'accessKeySecret': accesskey,
          'stsToken': stsToken, //1111
          'bucket': 'openbj',
          'endpoint': 'https://oss-cn-beijing.aliyuncs.com',
          'policy': policyBase64,
          'success_action_status': '200', //让服务端返回200,不然，默认会返回204
          'signature': signature
        });

        console.log(obj);
        let abort = false; //进度条显示
        let checkpoint_temp = true;
        let result = alioss.multitest(ossClient, file, checkpoint_temp, this.multiSuccess, '', this.uploadProgress, key);

      },
      uploadProgress(percent) {
        this.percent = percent * 100;
      },

      pictureHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureOnChange(file, fileList) {
      },
      pictureHandleSuccess(response) {
        this.pictureFileList = [];
        if(response.code == 200) {
          this.form.picturePath = response.data.fileId;
          let file = {
            name: response.data.filePath,
            url: response.data.filePath
          };
          this.pictureFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      pictureBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });
        
        return isJPG && isLt2M && isSize;
      },

      goBack() {
        this.$router.go(-1);
      },
      prev() {
        this.step = this.step - 1;
        if(this.form.validityType == 1) {
          this.form.validity = '';
        }
        if(this.step == 1) {
          let tempAudio = JSON.parse(JSON.stringify(this.form.auditionVideoStrList));
          this.form.auditionVideoStrList = [];
          this.$nextTick(_ => {
            this.form.auditionVideoStrList = JSON.parse(JSON.stringify(tempAudio));
          });

        }
      },
      changeCourse(val) {
        this.courseChild = this.courseChildData[val];
        this.form.ccId = '';
      },
      changeChildrenCourse(val) {
        this.searchCourse(val);
      },
      changeOpenClass(val) {
        if(val == 1) {
          this.form.openClassTime = dateFormat(new Date());
        } else {
          this.form.openClassType=2;
        }
      },
      changeValidityType(val) {
        if(val == 1) {
          this.form.validity = '';
          this.form.validityType=1;
          this.$refs.courseForm.clearValidate("validity");
        } else {
          this.form.validityType=2;
          this.form.validity = '';
        }

      },
      saveAndNext(val) {
        let params = this.form;
        if(this.form.preferentialBeginTime || this.form.preferentialEndTime) {
          if(!this.form.preferentialBeginTime) {
            this.$message.error('优惠开始时间不能为空！');
            return;
          }
          if(!this.form.preferentialEndTime) {
            this.$message.error('优惠截止时间不能为空！');
            return;
          }
          if(new Date(this.form.preferentialBeginTime).getTime() >= new Date(this.form.preferentialEndTime).getTime()) {
            this.$message.error('优惠开始时间不能大于截止时间！');
            return;
          }
        }
        let lecturers = JSON.parse(JSON.stringify(this.form.lecturer));
        let lecturer = [];
        for (let i in lecturers) {
          let l = {
            lecturer: lecturers[i]
          };
          lecturer.push(l);
        }
        this.form.commodityLecturerList = lecturer;
        let flag = true;
        if(this.selectedCategory instanceof Array) {
          if(this.selectedCategory.length > 0) {
            this.form.ccId = this.selectedCategory[this.selectedCategory.length-1];
          }
        } else {
          this.form.ccId = this.selectedCategory;
        }
        if(this.selectedOrgCategory.length > 0) {
          this.form.orgCcId = this.selectedOrgCategory[this.selectedOrgCategory.length-1];
        }

        if(this.loginOrgCode == 'blcuonline') {
          this.form.ccId = this.form.orgCcId;
        }
        
        let url = '/commodityInfo/saveCommodity';
        if(val == 1) {
          this.$refs['courseForm'].validate((valid) => {
            if (!valid) {
              this.$message.error('请正确填写信息！');
              flag = false;
            }
          });
          if(this.form.validityType == 1) {
            this.form.validity = -1;
          }
          else if(this.form.validity==''){
            this.$message.error('请输入有效期');
            flag = false;
          }
          if(this.form.openClassType == 1) {
            this.form.openClassTime = "1970-01-01 00:00:00";
          }
        }
        if (val == 2) {
          url = '/commodityInfo/updateCourseIntroduceByCommodityId';
          if(!this.form.courseIntroduce) {
            this.$message.error('请填写课程简介');
            flag = false;
          }
        }
        if (val == 3) {
          url = '/commodityInfo/updateCommodityByCommodityId';
          for(let i in this.form.commodityList) {
            this.form.commodityList[i].childCommoditySort = i;
          }
        }

        if(flag) {
          https.fetchPost(url, params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              if (val == 3) {
                this.$router.push({path: 'commodityPackage'});
              }
              if (val == 1) {
                if (!this.form.commodityId) {
                  this.form.commodityId = data.data.data;
                  this.form.comCommodityId = data.data.data;
                } else {
                  this.form.comCommodityId = this.form.commodityId;
                }
              }
              if (val == 2) {
                this.searchSelectedCommodity();
              }
              if (val != 3) {
                this.step = this.step + 1;
              }

            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }

          }).catch(err => {
                console.log(err);
                this.$message.error('网络错误');
              }
          );
        }
      },
      onEditorChange({editor, html, text}) {

      },
      uploadSuccess(res, file) {
        console.log(res);
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, 'image', res.data.filePath);
        quill.setSelection(length + 1);
        this.quillUpdateImg = false;
      },
      uploadEnglishSuccess(res, file) {
        let quill = this.$refs.myQuillEditorEnglish.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, 'image', res.data.filePath);
        quill.setSelection(length + 1);
        this.quillUpdateImg = false;
      },
      uploadError() {
        this.quillUpdateImg = false;
        this.$message.error('图片插入失败');
      },
      beforeUpload() {
        this.quillUpdateImg = true;
      },
      //加载本部分类
      loadCourseCategory() {
        let params = {
          orgCode: this.$store.state.eblcuOrg
        };
        https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.categoryOptions = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      selectCategoryData(val) {
        if(val == this.$store.state.eblcuOrg) {
          this.showOrgCC = false;
          this.selectedOrgCategory = [];
          return;
        } else {
          this.showOrgCC = true;
        }
        //http://localhost:8080/news/index
        if(val == undefined) {
          val = '';
        }
        let params = {
          orgCode: val
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          this.categoryOrgOptions = [];
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data != null) {
              this.categoryOrgOptions = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      changeCategory(value) {
        console.log(value);
      },
      pre(commodity) {
        let index = 0;
        for(let i in this.commodity) {
          if(commodity.commodityId == this.commodity[i].commodityId) {
            index = parseInt(i);
          }
        }
        if(index == 0) {
          this.$message({
               type: 'info',
               message: '操作失败:已经置顶！'
          });
        }else {
          this.commodity.splice(index-1,0,commodity);
          this.commodity.splice(index+1,1);
          this.selectedCommodiys.splice(index-1,0,this.selectedCommodiys[index]);
          this.selectedCommodiys.splice(index+1,1);
          this.form.commodityList.splice(index-1,0,this.form.commodityList[index]);
          this.form.commodityList.splice(index+1,1);

        }
        
      },
      sortCommodity(a,b) {
        console.log(a);
        console.log(b);
      },
      next(commodity) {
        
        let index = 0;
        for(let i in this.commodity) {
          if(commodity.commodityId == this.commodity[i].commodityId) {
            index = parseInt(i);
          }
        }
        if(index == this.commodity.length-1) {
          this.$message({
            type: 'info',
            message: '操作失败:已经到底！'
          });
        } else {
          this.commodity.splice(index+2,0,commodity);
          this.commodity.splice(index,1);
          this.selectedCommodiys.splice(index+2,0,this.selectedCommodiys[index]);
          this.selectedCommodiys.splice(index,1);
          this.form.commodityList.splice(index+2,0,this.form.commodityList[index]);
          this.form.commodityList.splice(index,1);
        }
      },
      deleteCommodity(commodity) {
        let index = 0;
        for(let i in this.commodity) {
          if(commodity.commodityId == this.commodity[i].commodityId) {
            index = i;
          }
        }
        this.commodity.splice(index,1);
        this.selectedCommodiys.splice(index, 1);
        this.form.commodityList.splice(index, 1);
        
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.teacherData = this.teacherList.filter(item => {
              return item.teacherName.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
            for(let i in this.teacherData1) {
              let flag = true;
              for(let j in this.teacherData) {
                if(this.teacherData1[i].teacherId == this.teacherData[j].teacherId) {
                  flag = false;
                }
              }
              if(flag) {
                this.teacherData.push(this.teacherData1[i]);
              }

            }
          }, 200);
        } else {
          this.teacherData = [];
        }
      },
      changeLecturer(val) {
        this.teacherData = [];
        this.form.lecturer = [];
        this.searchTeacher(val);
        this.selectCategoryData(val);
      },
      selectLecturer(value) {
        let teacherData1 = [];
        for (let i in this.teacherData){
          for(let j in value) {
            if(value[j] == this.teacherData[i].teacherId) {
              teacherData1.push(this.teacherData[i]);
            }
          }
        }
        this.teacherData1 = teacherData1;
      },
      searchCourse(ccid, courseId) {
        if (!ccid) {
          return;
        }
        let params = {
          categoryTwoId: ccid
        };
        https.fetchPost('/course/getCourseByType', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let courseList = data.data.data;
            this.courseList = courseList;
            for (let index in courseList) {
              if (courseId == courseList[index].courseId) {
                this.courseName = courseList[index].name;
              }
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      querySearch(queryString, cb) {
        var restaurants = this.courseList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
        };
      },
      handleSelect(item) {
        this.form.courseId = item.courseId;
        this.courseName = item.name;
      },
      searchTeacher(orgCode) {
        ///managerTeacher/getOrganizationList
        let params = {
          ccId: '',
          orgCode: orgCode
        };
        https.fetchGet('/managerTeacher/getOrganizationList', params, 'from').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            this.teacherList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },

      searchSelectedCommodity() {
        let params = {
          commodityId: this.form.commodityId,
          orgCode: this.form.orgCode
        };
        https.fetchPost('/commodityInfo/selectListAll', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            if(data.data.data) {
              if(data.data.data.length == 1) {
                let commodityList = data.data.data[0].commodityInfoFileVoList;
               if(commodityList) {
                 this.commodity = commodityList;
                 for(let i in this.commodity) {
                   let teacher = '';
                   let subTeacher = '';
                   let teachers = this.commodity[i].commodityLecturerList;
                   for (let j in teachers) {
                     teacher +=teachers[j].lecturerName+' ';
                     if(j < 3) {
                       subTeacher += teachers[j].lecturerName+' ';
                     }
                     if(j == 3) {
                       subTeacher += '...';
                     }
                   }
                   this.$set(this.commodity[i],'teacherList', teacher);
                   this.$set(this.commodity[i],'subTeacher', subTeacher);
                 }
                 for(let i in commodityList) {
                   this.selectedCommodiys.push(commodityList[i].commodityId);
                   let commodity = {
                     commodityId: commodityList[i].commodityId,
                     childCommoditySort: i
                   };
                   this.form.commodityList.push(commodity);
                 }
               }
              }
              
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      searchCommodity() {
        let params = {
          isPacking: 1,
          specType: 0,
          ccId: this.form.ccId,
          orgCode: this.form.orgCode,
          courseType: 0,
        };
        https.fetchPost('/commodityInfo/selectListAll', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {

            this.commodityData = data.data.data;
            for(let i in this.commodityData) {
              let teacher = '';
              let subTeacher = '';
              let teachers = this.commodityData[i].commodityLecturerList;
              for (let j in teachers) {
                teacher +=teachers[j].lecturerName+' ';
                if(j < 3) {
                  subTeacher += teachers[j].lecturerName+' ';
                }
                
                if(j == 3) {
                  subTeacher += '...';
                }
              }
              this.$set(this.commodityData[i],'teacherList', teacher);
              this.$set(this.commodityData[i],'subTeacher', subTeacher);
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
          console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      selectOrg() {
        https.fetchGet('/managerOrganization/getOrganizationList','', 'from' ).then((data) => {
          let code = data.data.code;
          if(code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
            }
        );
      },
      getPlayUrl(fileId) {
        this.videoSrc = video.filePath;
        this.videoType = video.videoType;
        this.uploadMethodDataType = 2;
        /*let params = {
          videoInfoId: fileId
        };
        https.fetchPost('/file/getPlayUrl', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.videoSrc = data.data.data.url;
            this.uploadMethodDataType = 2;
            this.selectPlayer();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );*/
      },
       searchCommodityinfoByAll(){//获取课程信息
        this.selectedCategory='';
        let params = {
          all: this.form.courseName
        };
        this.https.fetchPost('/commodityInfo/searchCommodityinfoByAll', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
              let commodityData = data.data.data;
              if(commodityData){
                this.selectedCategory=commodityData.ccId;
              }
          } 
          else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      checkValidity(value){
        this.form.validityType = 2;
      },
      selectCommodityDetail(commodityId) {
        let params = {
          commodityId: commodityId
        };
        this.https.fetchPost('/commodityInfo/getByCommodityId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {

            this.form = data.data.data;
            this.$set(this.form,'lecturer',[]);
            this.$set(this.form,'commodityList',[]);
            let pictureFile = {
              name: '123.png',
              url: this.form.picturePathView
            };
            this.pictureFileList.push(pictureFile);
            this.hidePictureUpload = this.pictureFileList.length >= this.pictureLimitCount;
            let auditionVideoFile = {};
            if(this.form.auditionVideoVo) {
              auditionVideoFile = {
                name: this.form.auditionVideoVo.fileName,
                url: this.form.auditionVideoVo.filePath
              };
              this.auditionVideoFileList.push(auditionVideoFile);
              this.getPlayUrl(this.form.auditionVideoVo);
            }

            this.hideAuditionVideoUpload = this.auditionVideoFileList.length >= this.auditionVideoLimitCount;
            let commodityLecturerList = this.form.commodityLecturerList;
            if(this.form.ccIdString != null) {
              this.selectedCategory = this.form.ccIdString.split('/');
            }
            if(this.form.orgCcIdString != null) {
              this.selectedOrgCategory = this.form.orgCcIdString.split('/');
              console.log(this.selectedOrgCategory);
            }
            this.selectCategoryData(this.form.orgCode);
            if(this.form.preferentialBeginTime) {
              this.form.preferentialBeginTime = this.form.preferentialBeginTime;
            }
            if(this.form.preferentialEndTime) {
              this.form.preferentialEndTime = this.form.preferentialEndTime;
            }
            for (let i in commodityLecturerList) {
              this.form.lecturer.push(commodityLecturerList[i].lecturer);
              console.log(commodityLecturerList[i].lecturer);
              let teacher = {
                teacherName: commodityLecturerList[i].lecturerName,
                teacherId: commodityLecturerList[i].lecturer
              };
              this.teacherData.push(teacher);
              this.teacherData1.push(teacher);
            }
            let validity = this.form.validity;
            if(validity == -1) {
              this.$set(this.form,'validityType',1);
              this.form.validity = '';
            } else {
              this.$set(this.form,'validityType',2);
            }
            let openClassTime = this.form.openClassTime;
            if(openClassTime == -28800000) {
              this.$set(this.form,'openClassType',1);
              this.form.openClassTime =dateFormat(this.form.openClassTime);
            } else {
              this.$set(this.form,'openClassType',2);
              this.form.openClassTime = dateFormat(this.form.openClassTime)
            }
            this.courseId = this.form.courseId;
            this.searchCourse(this.form.ccId, this.form.courseId);
            if (this.form.orgCode) {
              this.searchTeacher(this.form.orgCode);
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      addRule(prop, rule) {
        this.$set(this.rules, prop, rule);
      },
    },
    filters: {
      teacherFilter(val) {
        if(val.length > 6) {
          val = val.substring(0,6);
          return val+"...";
        }
        return val;
      },
    },
    watch: {
      'form.preferentialBeginTime': {
        immediate: true,
        handler (newVal) {
          console.log(new Date(this.form.preferentialBeginTime).getTime());
          if (this.form.preferentialBeginTime || this.form.preferentialEndTime) {
            this.addRule('preferential', [{ required: true, message: '请输入优惠价', trigger: 'blur' },{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);

          } else {
            this.addRule('preferential', [{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
          }

          if(this.form.preferentialBeginTime) {
            this.addRule('preferentialEndTime', [{ required: true, message: '请输入优惠截止时间', trigger: 'blur' }]);
            this.preferentialTime = 'preferentialEndTime';
            // this.endTimeHoursRule = this.form.preferentialBeginTime.substr(11)+" - " + "23:59:59";
          }else {
            // this.addRule('preferentialEndTime', []);
            this.endTimeHoursRule = '00:00:00 - 23:59:59';
          }
        }
      },
      'form.preferentialEndTime': {
        immediate: true,
        handler (newVal) {
          if (this.form.preferentialBeginTime || this.form.preferentialEndTime) {
            this.addRule('preferential', [{ required: true, message: '请输入优惠价', trigger: 'blur' },{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
            // this.addRule('preferentialBeginTime', [{ required: true, message: '请输入优惠开始时间', trigger: 'blur' }]);
          } else {
            this.addRule('preferential', [{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
            // this.addRule('preferentialBeginTime', [])
          }

          if(this.form.preferentialEndTime) {
            // this.addRule('preferentialBeginTime', [{ required: true, message: '请输入优惠开始时间', trigger: 'blur' }]);
            // let tiem = "00:00:00"+" - "+ this.form.preferentialEndTime.substr(11);
            // console.log(tiem);
            // this.startTimeHoursRule = tiem;
            // console.log(this.startTimeHoursRule);
          }else {
            // this.addRule('preferentialBeginTime', []);
            this.startTimeHoursRule = '00:00:00 - 23:59:59';
          }
        }
      },
    },
    created: function() {
      // 机构编码-远汉      blcuonline
      this.loginOrgCode = this.$store.state.orgCode;
      if(this.loginOrgCode == 'blcuonline') {
        this.form.lessonType = 11;
        this.form.orgCode = 'blcuonline';
        this.changeLecturer('blcuonline');
      }
      this.orgType = this.$store.state.orgType;
      if(this.orgType!=1){
        this.showOrgCC=true;
        this.form.orgCode = this.$store.state.orgCode;
      }
      let commodityId = this.$route.query.commodityId;

      if(commodityId) {
        this.selectCommodityDetail(commodityId);
      }
      
     
      this.loadCourseCategory();
      if(this.form.orgCode) {
        this.searchTeacher(this.form.orgCode);
        this.selectCategoryData(this.form.orgCode);
      }
      this.selectOrg();
      
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
      
    }
  };
</script>

<style>
    .avatar-uploader {
        width: 500px;
    }
    
    .t_top {
        margin-bottom: 10px;
    }
    
    .t_center {
        width: 60%;
        margin: 0 auto;
    }
    
    .t_center1 {
        width: 100%;
        margin: 0 auto;
    }
    
    .avatar-uploader {
        width: 95%;
    }
    
    .ql-editor {
        min-height: 300px;
    }
    
    .hide .el-upload--picture-card {
        display: none;
    }
    
    .time {
        font-size: 13px;
        color: #999;
    }
    
    .bottom {
        margin-top: 8px;
        line-height: 5px;
    }
    
    .button {
        padding: 0;
        float: right;
    }
    
    .image {
        width: 100%;
    }
    
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }
    .sub_teacher {
        width: 50px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-label::before {
        content: '行高';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='initial']::before {
        content: '默认';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1']::before {
        content: '1';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.5']::before {
        content: '1.5';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.75']::before {
        content: '1.75';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='2']::before {
        content: '2';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='3']::before {
        content: '3';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='4']::before {
        content: '4';
    }
    .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='5']::before {
        content: '5';
    }
    .ql-snow .ql-picker.ql-lineheight {
        width: 70px;
    }
</style>
<style scoped>
    .input_ >>> .el-input-group{
        vertical-align: 0;
    }
    .edit_transfer >>> .el-transfer-panel {
        width: 350px;
    }
</style>